import type { PromoRecipesProps } from './component';
import type { FC } from 'react';
import React, { memo, Suspense } from 'react';

const ComponentLoad = React.lazy(async () => await import('./component'));

const PromoRecipes: FC<PromoRecipesProps> = props => (
  <Suspense fallback={null}>
    <ComponentLoad {...props} />
  </Suspense>
);

export default memo(PromoRecipes);
